module.exports = __webpack_public_path__ + "static/media/Follower_Button-8.f37b0391.png";